import extract from '../core/extract'
import i18n from './i18n'

export default function(error) {
    return extract(i18n.errorTypeEnum, error.type, null)
}


// WEBPACK FOOTER //
// ./lib/reference/errors.js